import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { StringDateTimeInput } from '@mc/react-datetime';
import { useTheme } from '../useTheme';
import { FormItem } from './FormItem';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import {
  DATE_INPUT_POPOVER_PROPS,
  MAX_FUTURE_DATE,
  MIN_FUTURE_DATE,
} from '../consts';
import classNames from 'classnames';
import { IconRightElementForInput } from '../IconRightElementForInput';

export type DateTimeProps = VFFieldProps<
  React.ComponentProps<typeof StringDateTimeInput>
>;
export const DateTime = React.forwardRef<HTMLInputElement, DateTimeProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      ...other
    },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FormItem
        name={name}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
      >
        <Field name={name}>
          {({ input: { value, onChange, onBlur } }: FieldRenderProps<any>) => {
            return (
              <StringDateTimeInput
                highlightCurrentDay
                rightElement={
                  <IconRightElementForInput
                    htmlFor={name}
                    icon={faCalendarAlt}
                  />
                }
                {...other}
                maxDate={MAX_FUTURE_DATE}
                minDate={MIN_FUTURE_DATE}
                popoverProps={DATE_INPUT_POPOVER_PROPS}
                className={classNames(
                  `${ns}-date-time final-form-input-right-visual`,
                  inputClassName
                )}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                onBlur={(newValue) => {
                  onBlur({
                    target: { name, value: newValue },
                  } as any as React.FocusEvent<HTMLElement>);
                }}
                value={value}
                disabled={disabled}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
